/* eslint-disable curly */
/* eslint-disable prettier/prettier */
import { useLazyQuery, useQuery } from "@vue/apollo-composable";
import { GetSlugInfoDocument } from "@/core/api/graphql/types";
import type { GetSlugInfoQuery, QuerySlugInfoArgs } from "@/core/api/graphql/types";
import type { MaybeRefOrGetter } from "vue";


export function useGetSlugInfo(payload: MaybeRefOrGetter<QuerySlugInfoArgs>) {
  return useQuery(GetSlugInfoDocument, payload, { fetchPolicy: "cache-and-network" });
}

export async function getSlugInfo(params : QuerySlugInfoArgs) : Promise<GetSlugInfoQuery | undefined>
{
  const slugInfoQuery = useLazyQuery(GetSlugInfoDocument, params, { fetchPolicy: "cache-first" });

  const result = await slugInfoQuery.load();

  if (slugInfoQuery.error.value)
    throw `Error fetching pages by params '${JSON.stringify(slugInfoQuery)}': ${JSON.stringify(slugInfoQuery.error.value)}`;

  if (result)
    return result;
    
  return undefined;
}
